/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2024-01-12 10:38:27
 */
import './index.scss'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Layout, Spin, Modal } from 'antd'
import AntdProvider from '@/components/AntdProvider'
import logo from '../../images/footer-logo.png'
import {
  fetchQrcode,
  fetchQrcodeStatus,
  invalidToken
} from '../../actions/geoData'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import sensors from '../../utils/sensors'
import ImportPage from './BatchImport'
import ContactUS from '../components/ContactUS'
import { CloseOutlined, CustomerServiceOutlined } from '@ant-design/icons'

import PageHeader from '@/components/PageHeader'
const { Content } = Layout

const TOKEN_STORAGE_KEY = 'geoDataToken'

const QRCode = ({ qrcode, token }) => {
  const loading = useAppSelector((state) => state.main.loading)

  useEffect(() => {
    if (token) {
      sensors.track('web_enter_page_watermark_item_add_multi_code', {
        token
      })
    }
  }, [token])

  return (
    <Content className="content geo-data-content">
      {loading ? (
        <Spin className="qr-code-wrapper" />
      ) : (
        qrcode && (
          <div className="qr-code-wrapper">
            <img src={qrcode} alt="" />
            <p>扫码开始上传水印选项</p>
          </div>
        )
      )}
    </Content>
  )
}

const GeoData = () => {
  const [qrcode, setQrcode] = useState('')
  const dispatch = useAppDispatch()

  const [token, setToken] = useState<string>('')
  const [isTokenScaned, setIsTokenScaned] = useState<boolean>(false)
  const statusTimer: any = useRef(null)
  const filenameRef = useRef('')

  const reportSaClickEvent = (clickItem) => {
    sensors.track('web_click_page_watermark_item_add_multi_upload', {
      clickItem,
      fileName: filenameRef.current,
      token: token,
      pageType: 'QRcodeToken',
      fromPlace: 'personalWatermark'
    })
  }

  const reportSaUploadEvent = (content) => {
    sensors.track('web_get_action_watermark_item_add_multi_upload', {
      content,
      fileName: filenameRef.current,
      token: token,
      fromPlace: 'personalWatermark'
    })
  }

  const handleFetchQrcode = useCallback(() => {
    dispatch(fetchQrcode()).then((data) => {
      if (data.status === 0) {
        console.log('二维码获取成功')
        setQrcode('data:image/png;base64,' + data.QR_code)
        setToken(data.token)
        setIsTokenScaned(false)
      } else {
        console.log('二维码获取失败')
        Modal.error({
          title: '二维码获取失败',
          content: '请稍后重试'
        })
      }
    })
  }, [])

  useEffect(() => {
    console.log('token changed', token)
    if (token === '') return
    clearInterval(statusTimer.current)
    handleFetchStatus()
    handlePollingFetchStatus()
  }, [token])

  const handleFetchStatus = () => {
    dispatch(fetchQrcodeStatus({ token })).then((data) => {
      if (data.status === 1) {
        console.log('二维码过期，重新获取')
        clearInterval(statusTimer.current)
        setIsTokenScaned(false)
        handleFetchQrcode()
      } else if (data.status === 0) {
        if (data.scan_status === 1) {
          console.log('扫码成功')
          clearInterval(statusTimer.current)
          setIsTokenScaned(true)
          localStorage.setItem(TOKEN_STORAGE_KEY, token)
        } else if (data.scan_status === 0) {
          console.log('等待扫描……')
        }
      }
    })
  }

  const handlePollingFetchStatus = () => {
    console.log('开始轮询二维码扫描状态')
    statusTimer.current = setInterval(() => {
      handleFetchStatus()
    }, 2000)
  }

  const handleInvalidToken = useCallback(() => {
    dispatch(invalidToken({ token })).then((data) => {
      if (data.status === 0) {
        handleFetchQrcode()
      }
    })
  }, [token])

  useEffect(() => {
    const storageToken = localStorage.getItem(TOKEN_STORAGE_KEY)
    if (storageToken) {
      console.log('历史任务状态查询')
      setToken(storageToken)
    } else {
      console.log('无历史任务，请求二维码')
      handleFetchQrcode()
    }
  }, [])

  return (
    <AntdProvider>
      <Layout className="geo-data">
        <PageHeader
          className="Header"
          title="批量添加选项"
          extra={
            <div className="header-extra">
              <ContactUS fromPage="批量添加选项">
                <span
                  className="service"
                  onClick={() => reportSaClickEvent('contactUs')}
                >
                  <CustomerServiceOutlined />
                  联系客服
                </span>
              </ContactUS>

              <CloseOutlined
                className="close"
                onClick={() => {
                  reportSaClickEvent('close')
                  if (token && isTokenScaned) {
                    handleInvalidToken()
                  } else {
                    window.location.href = '/'
                  }
                }}
              />
            </div>
          }
        />
        {token && isTokenScaned ? (
          <ImportPage
            token={token}
            onFinish={handleFetchStatus}
            afterUpload={(filename) => (filenameRef.current = filename)}
            reportSaClickEvent={reportSaClickEvent}
            reportSaUploadEvent={reportSaUploadEvent}
          />
        ) : (
          <QRCode qrcode={qrcode} token={token} />
        )}
        <div className="footer">
          <img className="logo" src={logo} alt="" />
        </div>
      </Layout>
    </AntdProvider>
  )
}

export default GeoData
